import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Home_page_product3_single_item from "./Home_page_product3_single_item";
import "./ProductDetails.css";
import Top_Header from "./Top_Header";
import Header from "./Header";
import About_p from "./About_p";
import Footer from "./Footer";
import ImageSlider from './ImageSlider'
import StickyComponent from "./Sticky_component";
import { Search } from "lucide-react";
import StarRating from "./Rating";
import BankOffersSlider from "./BankOffer_slider";
import SpecificationsTable from "./SpecificationsTable";

function ProductDetails() {
  // const productId = "RS72R50112C"; 
  const productId = useParams().productId;
  //console.log("Product ID:", productId);
  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentImage, setCurrentImage] = useState('');
  const [middleContent, setMiddleContent] = useState('description');
  const [productQuantity, setProductQuantity] = useState(1);
  const [addedToCartNotification, setAddedToCartNotification] = useState(false);
  const [compareButtonText, setCompareButtonText] = useState('Compare');
  const [pincode, setPincode] = useState('');
  const [message, setMessage] = useState('');
  const [isPincodeValid, setIsPincodeValid] = useState(false);
  const [avgRating, setAvgRating] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [rating, setRating] = useState(0);
  const [userReview, setUserReview] = useState('');
  const [token, setToken] = useState('');
  const navigate = useNavigate();
  const [showReviewMessage, setShowReviewMessage] = useState(false);
  const [reviewMessage, setReviewMessage] = useState('');
  const [width, setWidth] = useState(window.innerWidth);
  const [inStock, setInStock] = useState(true);
  const [stockQuantity, setStockQuantity] = useState(0);
  const [selectedAvailabileOffers, setSelectedAvailabileOffers] = useState('bank offers');
  const [exchangeOffersOptions, setExchangeOffersOptions] = useState([{
    "offer": "Exchange Offer",
    "value": 0
  }, {
    "offer": "exchnage offer 2",
    "value": 1000
  }]);
  // const [specification, setSpecification] = useState({
  //   // brand: 'Godrej',
  //   // manufacturer: 'Godrej & Boyce Manufacturing Company LimitedManufacturer Name & Address: Pirojshanagar Vikhroli Mumbai-400079 India',
  //   // modelName: 'WTEON ADR 70 5.0 PFDTN GPGR',
  //   // packer: 'Godrej & Boyce Manufacturing Company Limited',
  //   // functionType: 'Fully Automatic Top Load',
  //   // importer: 'Godrej & Boyce Manufacturing Company Limited',
  //   // energyRating: '5',
  //   // itemWeight: '29.5 kg',
  //   // washingCapacity: '7 kg',
  //   // itemDimensions: '56.5 x 91 x 56.5 Cm (LxWxH)',
  //   // washingMethod: 'Pulsator',
  //   // netQuantity: '1',
  //   // maximumSpinSpeed: '800rpm'
  // });
  const [specification, setSpecification] = useState({});

  async function fetchProductDetails() {
    try {
      // const response = await fetch(
      //   "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data",
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //     body: JSON.stringify({
      //       queryStringParameters: {
      //         field: "Model",
      //         value: productId,
      //       },
      //     }),
      //   }
      // );
      console.log("model name", productId);
      const response = await fetch(
        `https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/excel-data?field=Model&value=${encodeURIComponent(productId)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      )
      const data = await response.json();
      console.log("Data of product details page:", data);
      if (response.ok) {

        // const cleanedBody = data.body.replace(/NaN/g, "null");
        // const parsedData = JSON.parse(cleanedBody);
        // console.log("Parsed data of product details page:", parsedData);
        return data[0];
      } else {

      }

    } catch (error) {
      console.error("Error fetching product details:", error);
      return null;
    }
  }

  async function fetchrelatedProducts(catagory) {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/excel-data",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            queryStringParameters: {
              field: "Categories",
              value: catagory,
            },
          }),
        }
      );

      const data = await response.json();
      const cleanedBody = data.body.replace(/NaN/g, "null");
      const parsedData = JSON.parse(cleanedBody);
      if (Array.isArray(parsedData)) return parsedData;
      else return [];
    } catch (error) {
      console.error("Error fetching related products:", error);
    }
  }

  async function fetchReview(productId) {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/review-retrieve", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "product_id": productId
        })
      });
      const data = await response?.json();
      //console.log("Parsed data of review of product details", data);
      if (data.statusCode == 200) return data.body;

    } catch (error) {
      console.error("Error fetching review of product:", error);
    }
  }

  async function stockCheck(productModel) {
    try {
      const response = await fetch(
        "https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/stock-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "sku": productModel
        })
      });
      const data = await response?.json();
      // console.log("in stock data", data);
      //console.log("in stock quantity",data?.body?.ProductStock[0]?.Available_Qty);
      return data?.body?.ProductStock[0]?.Available_Qty;
    } catch (error) {
      console.log(error);
    }
  }

  const fetchProductSpecifications = async (model) => {
    try {
      const response = await fetch(
        "https://ub3uejdxxh.execute-api.ap-south-1.amazonaws.com/dev/specificationFetcher",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            "model_no": model
          })
        }
      )
      const data = await response.json();
      console.log("product specification", data);
      if (data?.Specification) {
        const cleanedBody = data.Specification.replace(/NaN/g, "null").replace(/'/g, '"');

        const parsedData = JSON.parse(cleanedBody);
        console.log("parsed product specification", parsedData);
        return parsedData;
      } else {
        return {};
      }
    } catch (error) {
      console.log("error in fetching product specification", error);
      return {};
    }
  }
  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      try {
        // First fetch product details since other requests depend on it
        const fetchedProduct = await fetchProductDetails();
        //console.log(fetchedProduct);
        setProduct(fetchedProduct);
        setCurrentImage(`https://khoslaslider.s3.ap-south-1.amazonaws.com${fetchedProduct?.Images?.split(',')[0]}`);

        // Now that we have product details, run dependent fetches in parallel
        const [reviewData, relatedData, stockData, specificationData] = await Promise.all([
          fetchReview(fetchedProduct?.id),
          fetchrelatedProducts(fetchedProduct?.Categories),
          stockCheck(fetchedProduct?.Model),
          fetchProductSpecifications(fetchedProduct?.Model)
        ]);

        // Set all states after Promise.all resolves
        setReviews(reviewData?.reviews);
        setAvgRating(reviewData?.average_rating || 0);

        const limitedProducts = (relatedData?.length > 8) ? relatedData?.slice(0, 8) : relatedData;
        setRelatedProducts(limitedProducts);

        setStockQuantity(stockData);
        setInStock(stockData > 2);

        setSpecification(specificationData);

      } catch (error) {
        console.error("Error fetching product data:", error);
        // Handle error appropriately
      } finally {
        setLoading(false);
      }
    }

    fetchData();

    // Handle token retrieval
    const token = localStorage.getItem('token');
    if (token) {
      setToken(JSON.parse(token));
    }

    // Set up resize listener
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Clean up resize listener
    return () => window.removeEventListener("resize", handleResize);
  }, [productId]);



  if (loading) {
    return <div>Loading...</div>;
  }

  if (!product) {
    return <div>No product details available.</div>;
  }

  function handleCartClick() {
    const cart = JSON.parse(localStorage.getItem('cart')) || [];
    const existingItemIndex = cart.findIndex(item => item.model === product?.Model);
    if (existingItemIndex !== -1) {
      cart[existingItemIndex].quantity += productQuantity;
    } else {
      cart.push({
        model: product?.Model,
        name: product?.Name,
        price: product?.Sale_price || product?.Regular_price,
        url: `https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}`,
        quantity: productQuantity
      });
    }

    localStorage.setItem('cart', JSON.stringify(cart));
    setAddedToCartNotification(true);
    setTimeout(() => {
      setAddedToCartNotification(false);
    }, 3000);
    //console.log('Cart details', JSON.parse(localStorage.getItem('cart')) || []);
  }

  function handleCompare() {
    const existingCompareItems = JSON.parse(localStorage.getItem('compareItems')) || [];
    const isProductExists = existingCompareItems.findIndex(
      item => item.model?.toLowerCase() === product?.Model?.toLowerCase()
    );
    if (isProductExists !== -1) {
      //console.log('Product already exists in compare list');
      setCompareButtonText('Already Added');
      setTimeout(() => {
        setCompareButtonText('Compare');
      }, 3000);
      return;
    }
    const productToCompare = {
      sale_price: product?.Sale_price || null,
      regular_price: product?.Regular_price || null,
      description: product?.Short_description || null,
      stock: stockQuantity || null,
      weight: product?.Weight || null,
      brand: product?.Brands || null,
      image: `https://khoslaslider.s3.ap-south-1.amazonaws.com${product?.Images?.split(',')[0]}` || null,
      name: product?.Name || null,
      model: product?.Model || null,
      dimmensions: product?.Dimensions || null,
      sku: product?.sku || null,
      catagory: product?.Categories.split(",").flatMap(item => item.split(">")).map(item => item.trim())[0] || null
    };

    const updatedCompareItems = [...existingCompareItems, productToCompare];

    // Save updated array back to localStorage
    localStorage.setItem('compareItems', JSON.stringify(updatedCompareItems));

    //console.log('compare list', JSON.parse(localStorage.getItem('compareItems')));

    setCompareButtonText('Added');
    setTimeout(() => {
      setCompareButtonText('Compare');
    }, 3000);
  };

  async function checkPincode() {
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/pincode-check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "pincode": pincode
        })
      })

      const data = await response.json();
      //console.log(data);
      if (data.statusCode == 200) {
        setIsPincodeValid(true);
        setMessage("Delivery is available in your area");
      } else {
        setIsPincodeValid(false);
        setMessage("Delivery is not available in your area");
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  const handlePincodeChange = async (e) => {
    const value = e.target.value;
    setPincode(value);
    if (!value) {
      setMessage('');
      setIsPincodeValid(false);
    }
  };

  const handleReviewSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/review-rating', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        "product_id": product?.id,
        "token": token,
        "review_text": userReview,
        "rating": rating
      })
    });
    const data = await response.json();
    if (data.statusCode == 200) {
      setShowReviewMessage(true);
      setReviewMessage("Review submitted successfully");
      setTimeout(() => {
        setShowReviewMessage(false);
      }, 3000);
      const reviews = await fetchReview(product?.id);
      setReviews(reviews?.reviews);
      setAvgRating(reviews?.average_rating || 0);
    }
  }
  function handleBuyNow() {
    handleCartClick();
    setTimeout(() => {
      navigate('/cart')
    }, 1500)
  }


  return (
    <>
      <Top_Header />
      <Header />
      <ImageSlider></ImageSlider>
      {
        (addedToCartNotification) ?
          <div className="product-details-added-to-cart-notification">
            <p>{product?.Name} has been added to your cart </p>
            <a href="/cart">| View Cart -{'>'}</a>
          </div>
          : null
      }

      {
        (!product || product === 'N') ? <h1>
          No Such Product
        </h1> : <div>
          <div className="product-details-container">
            <div className="product-details-images-container">
              <div className="product-details-discount">
                {(product?.Sale_price) ?
                  Math.floor(((product?.Regular_price - product?.Sale_price) / product?.Regular_price) * 100)
                  : 0}
                % off
              </div>
              <img src={currentImage} alt="" className="product-details-main-image" />
              <div className="product-details-images-thumbnails">
                {
                  product?.Images?.split(',').map((image, index) => {
                    // console.log("product page Imagestring ",product?.Images)
                    const trimmedImage = image?.trim();
                    return (
                      // console.log("product page images ", image),
                      <img src={`https://khoslaslider.s3.ap-south-1.amazonaws.com${trimmedImage}`} alt="" key={index} onClick={() => setCurrentImage(`https://khoslaslider.s3.ap-south-1.amazonaws.com${trimmedImage}`)} />
                    )
                  })
                }
              </div>
            </div>
            <div className="product-details-text-container">
              <div className="product-details-compare-button-container">
                <button className="product-details-compare-button" onClick={handleCompare}>
                  {compareButtonText}
                </button>
              </div>

              <h4>
                {product?.Name}
              </h4>
              <div>
                <ul dangerouslySetInnerHTML={{ __html: product?.Short_description }}></ul>
              </div>
              <div className="product-details-features">
                <div>
                  <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/01/VIVO-V30-5G-Classic-Black-12.png" alt="" />
                  <h5>Free Shipping</h5>
                </div>
                <div>
                  <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/01/VIVO-V30-5G-Classic-Black-10.png" alt="" />
                  <h5>Pay on Delivery</h5>
                </div>
                <div>
                  <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/01/VIVO-V30-5G-Classic-Black-7.png" alt="" />
                  <h5>Safe Delivery</h5>
                </div>
                <div>
                  <img src="https://khoslaslider.s3.ap-south-1.amazonaws.com/uploads/2023/01/VIVO-V30-5G-Classic-Black-8.png" alt="" />
                  <h5>Easy Installment</h5>
                </div>
              </div>
            </div>
            <div className="product-details-top-right-container">
              <div className="product-details-price-container">
                <div className="product-details-price-details-container">
                  <h2>₹{(product?.Sale_price) ? Number(product?.Sale_price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : Number(product?.Regular_price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h2>
                  <h5 className="product-details-in-stock">{inStock ? "" : "Out of Stock"}</h5>

                </div>

                <h4>(Inclusive of all taxes)</h4>
                <h4 className="price-details-old-price">MRP : <span className="old-price-strike">₹{(product?.Sale_price) ? product?.Regular_price.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : null}</span> </h4>
                <input type="number" className="product-details-product-quantity" placeholder="1" onChange={(e) => setProductQuantity(Number(e.target.value))} />
                <button className={inStock ? "product-details-add-to-cart" : "product-details-add-to-cart disabled"} onClick={handleCartClick} disabled={!inStock}>Add to Cart</button>
                <button className={inStock ? "product-details-buy-now" : "product-details-buy-now disabled"} onClick={handleBuyNow} disabled={!inStock}>Buy Now</button>
                <h5>Use pincode to check delivery info</h5>
                <div className="product-details-pincode-container">
                  <input type="text" placeholder="Enter Your Pincode" className="product-details-pincode" onChange={handlePincodeChange} />
                  <Search color="red" size={25} className="product-details-pincode-search-icon" onClick={checkPincode} />
                </div>

                <p style={{ color: isPincodeValid ? 'green' : 'red' }}>{message}</p>
              </div>
              {/* <div className="product-details-available-offers-container">
                <div className="product-details-available-offers-container-header">
                  <h4>Extra Deals Available</h4>
                  <button>See All</button>
                </div>

                <div className="product-details-available-offers-header">
                  <button className={selectedAvailabileOffers === "bank offers" ? "button-selected-offer" : ""} onClick={() => setSelectedAvailabileOffers("bank offers")}>Bank Offers</button>
                  <button className={selectedAvailabileOffers === "exchange offers" ? "button-selected-offer" : ""} onClick={() => setSelectedAvailabileOffers("exchange offers")}>Exchange Offers</button>
                </div>
                <div className="product-details-available-offers">
                  {
                    selectedAvailabileOffers === "bank offers" ? <BankOffersSlider /> : null
                  }
                  {
                    selectedAvailabileOffers === "exchange offers" ? <div>
                      <select className="product-details-exchange-offers">
                        {
                          exchangeOffersOptions.map((option, index) => (
                            <option key={index} value={JSON.stringify(option)}>{option.offer}-{option.value}</option>
                          ))
                        }
                      </select>
                    </div> : null
                  }
                </div>
              </div> */}
            </div>
          </div>

          <div className="product-details-middle-section">
            <div className="product-details-middle-section-header">
              {
                (product?.Description) ?
                  <div className={middleContent === 'description' ? 'selected' : ''} onClick={() => setMiddleContent('description')}>
                    <h5>Description</h5>
                  </div>
                  : null
              }
              {
                (true) ?
                  <div className={middleContent === 'specification' ? 'selected' : ''} onClick={() => setMiddleContent('specification')}>
                    <h5>Specification</h5>
                  </div>
                  : null
              }

              <div className={middleContent === 'review' ? 'selected' : ''} onClick={() => setMiddleContent('review')}>
                <h5>Review</h5>
              </div>

            </div>
            <div className="product-details-middle-section-content">
              {
                (middleContent === 'description') ?
                  <div dangerouslySetInnerHTML={{ __html: product?.Description }}></div>
                  : null
              }
              {
                (middleContent === 'specification') ?
                  <SpecificationsTable specifications={specification} />
                  : null
              }
              {
                (middleContent === 'review') ?
                  <>
                    {showReviewMessage &&
                      <div className="product-details-middle-section-content-review-notification">
                        {reviewMessage}
                      </div>
                    }
                    <div className="product-details-middle-section-content-review-container">
                      <div className="product-details-middle-section-content-review-container-rating">
                        <h5>RATING</h5>
                        <StarRating value={avgRating} customSize={width >= 768 ? "5vw" : "15vw"} />
                        <p>{`${reviews.length} Ratings`}</p>
                      </div>
                      <div className="product-details-middle-section-content-review-container-review">
                        <h5>Write Your Review</h5>
                        <div>
                          <p>Your Rating : </p>
                          <StarRating value={rating} onChange={setRating} precision={1} />
                        </div>
                        <div>
                          <p>Your Review : </p>
                          <textarea value={userReview} onChange={(e) => setUserReview(e.target.value)}></textarea>
                        </div>
                        <button className="product-details-middle-section-content-review-container-review-button" onClick={handleReviewSubmit}>Submit Review</button>
                      </div>
                    </div>

                    <div className="product-details-middle-section-content-review-container-review-list">
                      {
                        reviews?.length > 0 ?
                          reviews?.map((review) => (
                            <div className="product-details-middle-section-content-review-container-review-item">
                              <h5>Akash</h5>
                              <StarRating value={review?.rating} />
                              <p>{review?.review_text}</p>
                            </div>
                          ))
                          : <div className="product-details-middle-section-content-review-notification red">
                            No Reviews Yet
                          </div>
                      }
                    </div>
                  </>

                  : null
              }
            </div>
            <p>** Images shown here are for representational purpose only, actual may vary. All features, specifications and prices are subject to change without prior notice. Model availability may vary from location to location. Content on box may vary by model or country.</p>
            <p><strong>Model:</strong> {product?.Model} /  <strong>Category:</strong> {product?.Categories}</p>
          </div>

          {
            relatedProducts?.length > 0 ?
              <div className="product-details-related-products">
                <h2 className="product-details-related-products-header">Related Products</h2>
                <div className="product-details-related-products-container">
                  {
                    relatedProducts?.map((product) => (
                      <Home_page_product3_single_item product={product} />
                    ))
                  }
                </div>
              </div>
              : null
          }
        </div>
      }

      {
        <img src='https://khoslaslider.s3.ap-south-1.amazonaws.com/image/Kosla-Mascot.png' className='khosla_da_img' onClick={() => window.open(
          'https://api.whatsapp.com/send/?phone=919674425425&text&type=phone_number&app_absent=0',
          '_blank'
        )} />
      }

      <About_p />
      <Footer />

      <StickyComponent />
    </>


  );
}

export default ProductDetails;





